import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const SubjectsSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("subjectsSelect", true))
);

export default SubjectsSelectMultipleTester;
